import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberWarswords = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M61.088 2.924a1 1 0 0 1 .246 1.005l-1.098 3.506-.001.002c-1.16 3.758-3.236 7.158-6.007 9.939l-.012.011-15.89 15.42a1 1 0 1 1-1.392-1.435l15.884-15.414c2.545-2.557 4.446-5.675 5.506-9.113l.002-.004.53-1.692-1.699.526a22.25 22.25 0 0 0-9.115 5.507L32.718 26.976a1 1 0 0 1-1.436-1.392l15.33-15.8.01-.011a24.25 24.25 0 0 1 9.94-6.008l3.522-1.09a1 1 0 0 1 1.004.249M27.076 31.362a1 1 0 0 1 .022 1.415L15.89 44.326l.128.127 3.52 3.53.132.13 11.634-11.282a1 1 0 1 1 1.392 1.436l-12.23 11.86-.023.022-.11.1a1 1 0 0 1-1.376-.029l-.835-.825-3.515-3.525-.83-.82a1 1 0 0 1-.004-1.418l.105-.105 11.784-12.144a1 1 0 0 1 1.414-.022",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M14.71 44.345a1 1 0 0 1 1.413 0l3.529 3.528a1 1 0 0 1 0 1.414L10.53 58.41a2.54 2.54 0 0 1-3.592 0l-1.35-1.35a2.54 2.54 0 0 1 0-3.593zm.706 2.12L7.002 54.88a.54.54 0 0 0 0 .764l1.35 1.35c.21.211.554.211.764 0l8.415-8.414z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M10.213 39.853a1 1 0 0 1 1.414 0l12.52 12.52a1 1 0 0 1-1.414 1.414l-12.52-12.52a1 1 0 0 1 0-1.414M2.913 52.983a1 1 0 0 1 1.414 0l6.69 6.69a1 1 0 0 1-1.414 1.414l-6.69-6.69a1 1 0 0 1 0-1.414M2.913 2.923a1 1 0 0 1 1.006-.247l3.509 1.1a24.4 24.4 0 0 1 9.938 6.005l.012.012 32.85 33.85a1 1 0 0 1-.01 1.404l-5.18 5.18a1 1 0 0 1-1.404.01l-33.85-32.85-.011-.01a24.25 24.25 0 0 1-6.008-9.939v-.001l-1.1-3.508a1 1 0 0 1 .248-1.006m2.233 2.233.529 1.687a22.25 22.25 0 0 0 5.507 9.115l33.137 32.158 3.787-3.787-32.158-33.136a22.4 22.4 0 0 0-9.116-5.508z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M44.343 49.293a1 1 0 0 1 0-1.415l3.528-3.528a1 1 0 0 1 1.414 0l9.122 9.122a2.54 2.54 0 0 1 0 3.592l-1.35 1.35a2.54 2.54 0 0 1-3.593 0zm2.121-.708L54.88 57c.21.21.553.21.763 0l1.351-1.35a.54.54 0 0 0 0-.764l-8.415-8.415z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M53.787 39.853a1 1 0 0 1 0 1.414l-12.52 12.52a1 1 0 0 1-1.414-1.414l12.52-12.52a1 1 0 0 1 1.414 0M61.087 52.983a1 1 0 0 1 0 1.414l-6.69 6.69a1 1 0 0 1-1.414-1.414l6.69-6.69a1 1 0 0 1 1.414 0",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberWarswords;
